export default __webpack_public_path__ + "f56c81774e91024f940cb6834eaf2333.png";